import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Voltar',
      changePassword: 'Alterar senha',
      copiedVaultId: 'Copiado!',
      copyVaultID: 'Copie o ID do Vault',
      create: 'Criar',
      next: 'Próximo',
      notSure: 'Não tenho certeza',
      signUp: 'Inscreva-se',
      submit: 'Enviar',
      updatePassword: 'Atualizar senha',
    },
    Errors: {
      createReportFailed: 'Falha ao criar relatório.',
    },
    ReportStatus: {
      CLOSED: 'Fechado',
      INVESTIGATING: 'Investigando',
      NEW: 'Enviado',
      READ: 'Lido',
    },
    general: {
      navbar: {
        caseSettings: 'Configurações de caso',
        changePassword: 'Alterar senha',
        logOut: 'Sair',
        notifications: 'Notificações',
        notificationsDrawer: {
          appFileScanFailed: 'Um arquivo falhou na verificação de segurança',
          appReportMatch: 'Seu registro GoTogether foi correspondido',
          appReportReassigned: 'Um novo gerente de caso foi designado',
          case: 'Caso',
          caseAssigned: 'Caso atribuído a você',
          caseImporterJobCompleted: {
            PartialSuccess: 'A importação do seu caso foi concluída com erros',
            failure: 'A importação do seu caso falhou',
            success: 'Sua importação de caso foi concluída com sucesso',
          },
          caseLinked: 'Caso vinculado',
          caseTeamInvite: 'Adicionado ao caso',
          caseUnlinked: 'Caso desvinculado',
          dataSanitisation: 'Detalhes do relatório atualizados',
          emptyDescription: 'Volte mais tarde para novas notificações',
          emptyTitle: 'Você está totalmente atualizado',
          importId: 'ID de Importação:',
          learnMore: 'Aprenda mais',
          markAllAsRead: 'Marcar todos como lidos',
          newMessage: 'Nova mensagem',
          newReport: 'Novo relatório recebido',
          permissionRemoved: 'Removido do caso',
          postSSubmissionFile: 'Arquivo(s) de evidência adicionado(s)',
          report: 'Relatório',
          reportAssigned: 'Relatório atribuído a você',
          reportStatusChange: 'Status do relatório alterado',
          reporterAnonymised: 'Seus detalhes foram anonimizados',
          reporterReportSubmitted: {
            subtitle: 'Recomendamos que salve uma cópia do seu relatório',
            title: 'Relatório submetido',
          },
          mitigationPlanReminder: 'Aprovação do plano de mitigação necessária',
          staleCase: 'Caso não acionado',
        },
        privacyStatement: 'Declaração de privacidade',
        reporter: {
          myReports: 'Meus relatórios',
        },
        settings: 'Configurações',
        technicalSupport: 'Suporte técnico',
        title: 'Conta',
      },
      time: {
        day: 'Dia',
        days: 'Dias',
        hour: 'Hora',
        hours: 'Horas',
        minute: 'Minuto',
        minutes: 'Minutos',
        second: 'Segundo',
        seconds: 'Segundos',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Anônimo',
        autoTranslate: 'A auto-tradução está desativada por padrão.',
        backToMessages: 'Voltar para as mensagens',
        caseSettings: 'Configurações de caso.',
        changeInProfile:
          'Se você deseja alterar essa configuração, pode fazer isso em seu perfil',
        deletedByMessage: 'Excluído por {{author}}',
        deletedMessageLabel: 'Esta mensagem foi deletada',
        description:
          'Quando a tradução automática está ativada, todas as mensagens de relatório serão\n          automaticamente traduzidas usando IA com base no idioma padrão\n          selecionado em seu navegador.',
        descriptionSecondHalf:
          'A versão original de todas as mensagens é sempre preservada e pode ser encontrada no chat.',
        messagePlaceholder: 'Comece a digitar...',
        messageSettings: 'Configurações de mensagens.',
        originalMessages: 'Original',
        showMoreBanner: 'Saiba mais sobre traduções automáticas',
        titlev2: 'Leia todas as mensagens no seu idioma preferido.',
        translatedMessageLabel: 'Mensagem Traduzida',
        translatedMessages: 'Traduzido',
        understood: 'Entendido',
      },
      Country: {
        description: 'Em qual país você está baseado?',
        header: 'Em qual país você está baseado?',
        noOptions: 'Nenhum país encontrado',
        other: 'Outro',
        placeholder: 'Pesquisar um país...',
      },
      CreatePublicReport: {
        createReport: 'Criar novo relatório',
        helpPage: 'Vá para nossa página de ajuda',
        loginToOpr: 'Faça login para rastrear relatórios',
        or: 'ou',
        passwordPlaceholder: 'Insira a senha',
        phoneNumberLoginFailed:
          'Falha no login, número de telefone/PIN incorreto',
        phoneNumberPlaceholder: 'Insira o seu número de telefone',
        phoneNumberTooltip:
          'Insira o número de telefone que você usou para contatar o VaultTalk',
        pinPlaceholder: 'Insira o PIN',
        reportIntroductionParagraph1:
          'Ao relatar um incidente, algumas perguntas serão feitas para ajudá-lo a documentar sua experiência.',
        reportIntroductionParagraph2:
          'Antes de enviar, você tem a opção de permanecer anônimo para proteger sua privacidade.',
        reportIntroductionParagraph3:
          'Após enviar, você pode fazer login a qualquer momento para verificar o progresso do seu relatório e conversar com um gerente de caso.',
        reportIssue: 'Relatar um problema',
        usernameLoginFailed: 'Falha no login, nome de usuário/senha incorretos',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired:
              'É necessário informar o relacionamento com a empresa',
            reportedCategoryRequired: 'A categoria relatada é necessária',
          },
        },
        vaultId: 'ID do Vault',
        vaultIdPlaceholder: 'Insira seu Email ou ID do Vault',
        vaultIdTooltip:
          'Para relatórios anônimos, o ID do Vault é alfanumérico. Se o relatório não foi anônimo, o ID do Vault é o seu endereço de email.',
        vaultTalk: 'VaultTalk',
        yourPassword: 'Sua Senha',
        yourPhoneNumber: 'Seu Número de Telefone',
        yourPin: 'Seu Pin de 6 Dígitos',
        yourVaultId: 'Seu ID Vault',
      },
      CustomHeader: {
        companyLogo: 'Logotipo da empresa',
        openReporting: 'Abrir relatório',
        userSettings: 'Configurações do usuário',
      },
      Date: {
        approximateDescription:
          'Você se lembra da data aproximada em que o evento ocorreu?',
        approximatePlaceholder:
          'Exemplo: 6 meses atrás/ano passado/novembro passado',
        cancel: 'cancelar',
        clear: 'limpar',
        description: 'Você se lembra em que data o evento ocorreu?',
        header: 'Em que dia ocorreu?',
        ok: 'ok',
        placeholder: 'Exemplo: 21 de junho de 2020',
      },
      Description: {
        whatHappened: 'O que aconteceu?',
        whatHappenedPlaceholder: 'Use as suas próprias palavras...',
        whatHappenedText: 'Em suas próprias palavras, descreva o que aconteceu',
      },
      Details: {
        disclaimer:
          'Esses detalhes serão divulgados com o seu relatório. Se você deseja permanecer anônimo, certifique-se de que eles não contenham informações identificáveis.',
        emailPlaceholder: 'E-mail (opcional)',
        fullNamePlaceholder: 'Nome completo (opcional)',
        header: 'Seus detalhes',
        nonAnonSubtitle:
          'Por favor, forneça seu nome ou um endereço de email. Se você deseja receber notificações sobre este relatório, adicione um endereço de email adequado abaixo.',
        nonOptionalEmailPlaceholder: 'Email',
        nonOptionalFullNamePlaceholder: 'Nome Completo',
        subtitle:
          'Se você deseja receber notificações sobre este relatório, adicione um endereço de email apropriado abaixo.',
      },
      Emotion: {
        description: 'Como isso o fez se sentir? Qual foi o impacto?',
        header: 'Qual foi o impacto?',
        placeholder: 'Comece a digitar...',
      },
      Evidence: {
        addedHeading: 'Adicionado',
        deletedMessage: 'foi deletado',
        deletedStatus: 'Deletado',
        failedToOpenFileMessage:
          'Falha ao abrir arquivo. Por favor, tente novamente.',
        fileStatuses: {
          infectedUpload: 'Sinalizado pela verificação de segurança',
          passedUpload: 'Passou na verificação de segurança',
          pendingUpload: 'Verificação de segurança em progresso',
          readyForDownload: 'Pronto para download',
        },
        mobileErrorMessage:
          'Arquivos marcados: envie mensagem para o seu gerente de caso',
        nameHeading: 'Nome',
        statusHeading: 'Status',
        tableTitle: 'Evidência',
        webErrorMessage:
          'Arquivos sinalizados: Se o(s) seu(s) arquivo(s) foi/foram sinalizado(s), por favor, envie uma mensagem para o gerente do caso.',
      },
      FileUpload: {
        addFiles: 'Adicionar arquivos',
        addMoreFiles: 'Adicione mais arquivos',
        confirm: 'Confirmar',
        description:
          'Adicionar arquivos como evidência pode ajudar a apoiar a eficiência da resolução pelo seu gestor de caso. Por favor, considere o conteúdo do arquivo (incluindo metadados do arquivo) se desejar permanecer anônimo, e respeite os direitos dos outros indivíduos e as leis aplicáveis.',
        dragDrop: 'Arraste os arquivos aqui ou',
        errorMessage:
          'Arquivo(s) falhou(falharam) devido a um erro de rede. Clique abaixo para enviar uma mensagem ao seu gerente de caso para obter ajuda.',
        fileLimit: 'Limite de tamanho para cada arquivo: 100MB',
        fileUploadLimitText: 'Você só pode fazer upload de 10 arquivos',
        header: 'Adicione evidências',
        helpArticle: 'artigo de ajuda',
        highlighted: 'navegar pelos arquivos',
        information: 'Tipos de arquivos suportados',
        moreInformation:
          'Para mais informações, por favor, veja isso <a>artigo de ajuda</a>',
        postSubmissionErrorMessage:
          "Não conseguimos fazer upload de seus arquivos devido a um erro do sistema. Por favor, selecione 'confirmar' novamente.",
        tooltipAudio: 'Áudio:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Documentos:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Imagens:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Texto:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Vídeo:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'O arquivo é muito grande',
          invalidFileType: 'Tipo de arquivo não suportado: {{extension}}',
          systemError: 'Erro de sistema',
          tooManyFiles: 'O número máximo de arquivos é {{maxFiles}}',
        },
        uploadFiles: 'Fazer upload de arquivos',
      },
      Loading: {
        loading:
          'Por favor, aguarde enquanto enviamos seu relatório para um gerente de casos...',
        postSubmissionLoading:
          'Por favor, aguarde enquanto enviamos seu(s) arquivo(s)...',
      },
      Location: {
        description: 'Onde aconteceu?',
        header: 'Onde aconteceu?',
        placeholder: 'Exemplo: no escritório',
      },
      MessageListBox: {
        messageCaseManager: 'Gestor de incidentes de mensagem',
        report: 'Relatório {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Tradução desativada',
        enableTranslationLabelEnabled: 'Tradução ativada',
        enableTranslationsDescription:
          'Ative as traduções automáticas e leia todas as mensagens de relatório no seu idioma preferido. O idioma traduzido é baseado no idioma selecionado no seu dispositivo.',
        enableTranslationsHeader:
          'Ative as traduções automáticas para mensagens de relatórios',
        enableTranslationsSubDescriptionv2:
          'Você pode alternar entre o idioma traduzido e o original em cada chat.',
        updateTranslationFailed: 'A atualização da tradução falhou',
        updateTranslationSuccess:
          'Configuração de tradução atualizada com sucesso',
      },
      Password: {
        changePasswordHeader: 'Alterar senha',
        createNewPassword: 'Crie uma nova senha',
        createPasswordHeader: 'Sua senha',
        currentPasswordPlaceholder: 'Insira a senha atual',
        description:
          'Uma senha válida deve ter pelo menos 9 caracteres e conter uma letra maiúscula e um número',
        enterCurrentPassword: 'Insira sua senha atual',
        forgottenPasswordInstructions:
          'Insira seu ID alfanumérico Vault (não seu endereço de email) e endereço de email para redefinir sua senha.',
        newDescription:
          'Crie uma senha forte para manter sua conta segura. Comece a digitar para ver as diretrizes abaixo.',
        passwordPlaceholder: 'Criar uma senha',
        passwordResetRequestedDescription:
          'Se o seu ID Vault existir em nosso sistema, você receberá um email com instruções para redefinir sua senha.',
        passwordResetRequestedHeader: 'Link de redefinição de senha solicitado',
        reenterPlaceholder: 'Digite a senha novamente',
        subtitle:
          'Crie uma senha para enviar este relatório e acessá-lo no futuro',
        yourVaultId: 'Seu ID do Vault',
        yourVaultIdPlaceholder: 'Digite seu ID do Vault (ex. {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Você vai denunciar uma pessoa específica ou várias pessoas? Poderia indicar quem são ou descrevê-las?',
        header: 'Pessoas envolvidas',
        placeholder:
          'Comece a digitar e use uma vírgula para adicionar vários nomes ou descrições',
      },
      PoweredByVault: 'Powered by {{company}}',
      PrivacyStatement: 'Declaração de Privacidade do Produto',
      PublicMessageList: {
        myMessages: 'Minhas mensagens',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'Evidência adicionada ao relatório existente',
        backToReportId: 'Voltar para o relatório ID: {{reportId}}',
        description:
          'Adicionar arquivos como evidência pode ajudar a apoiar a eficiência da resolução pelo seu gerente de caso. Por favor, considere o conteúdo do arquivo (incluindo metadados do arquivo) se desejar permanecer anônimo e respeite os direitos de outras pessoas e as leis aplicáveis. Para mais informações, por favor veja isso <a>artigo de ajuda</a>',
        header: 'Adicione evidências adicionais ao relatório',
        vaultTalkOpenCaseHeader: 'Adicione evidências ao seu relatório',
      },
      PublicReport: {
        anonymous: 'Anônimo',
        backToReports: 'Voltar para os relatórios',
        skipped: 'Ignorado',
      },
      PublicReportCard: {
        addEvidence: 'Adicione evidências adicionais',
        messageCaseManager: 'Gestor de incidentes de mensagem',
        reportId: 'ID do relatório:',
        submitted: 'Enviado',
        vaultTalkClosedCaseCTA: 'Ver evidências',
        vaultTalkOpenCaseCTA: 'Adicionar Evidência',
        viewAdditionalEvidence: 'Visualizar evidência adicional',
        viewReport: 'Visualizar relatório',
      },
      PublicReportsList: {
        reportingSystem: 'Sistema de relatórios',
      },
      Question: {
        placeholder: 'Comece a digitar...',
        question: 'Forneça detalhes',
        questionText:
          'Por favor, compartilhe suas preocupações, atualizações ou questionamentos conosco.',
      },
      Relationship: {
        header: 'Seu relacionamento com a organização',
        tellUsAbout: 'Descreva o seu relacionamento com a organização.',
      },
      ResponsiveNavMenu: {
        messages: 'Minhas mensagens',
        reports: 'Meus relatórios',
      },
      Site: {
        description: 'Em qual local você está baseado?',
        header: 'Em qual local você está baseado?',
        noOptions: 'Nenhum local encontrado',
        other: 'Outro',
        placeholder: 'Pesquisar um local...',
      },
      SpamPuzzle: {
        dialog: 'Para continuar, resolva este quebra-cabeça',
      },
      SubmissionTypes: {
        reportIssue: 'Selecione uma categoria',
        whatType: 'Selecione a categoria que melhor descreve o seu relatório',
      },
      SubmitSuccess: {
        category: '<bold>Categoria:</bold> {{category}}',
        country: '<bold>País:</bold> {{country}}',
        dateSubmitted: '<bold>Data enviada:</bold> {{date}}',
        recordYourVaultID: 'Lembre-se dessas informações para login',
        successInformation: 'Mais informações',
        successMessage:
          'Seu relatório foi enviado e está pronto para revisão. Quaisquer arquivos anexados que necessitem de atenção serão sinalizados após o login. Faça login abaixo para visualizar atualizações de relatórios e enviar mensagens para o seu gerente de caso.',
        successSanitationMessage:
          'Guarde uma cópia para seus registros e mantenha seu Vault-ID seguro — você precisará dele para acessar atualizações e enviar mensagens para o gerente do seu caso.',
        successSanitationTagline:
          'Seu relatório foi enviado e armazenado com segurança.',
        successThankYou: 'Obrigado pelo seu relatório!',
        viewReport: 'Visualizar relatório',
      },
      Time: {
        approximateDescription:
          'Você se lembra do horário aproximado em que o evento ocorreu?',
        approximatePlaceholder: 'Exemplo: pela manhã/à tarde',
        description: 'Você se lembra da hora em que o evento ocorreu?',
        header: 'A que horas ocorreu?',
        invalidTime: 'O formato de hora deve ser HH:MM',
      },
      UserSettingsDialog: {
        changePassword: 'Alterar senha',
        closeDialog: 'Fechar diálogo',
        logout: 'Sair',
        messageSettings: 'Configurações de Mensagens',
        userSettings: 'Configurações do usuário',
      },
      Witnesses: {
        description: 'Você contou para alguém ou alguém viu o que aconteceu?',
        header: 'Alguma testemunha?',
        placeholder: 'Comece a digitar...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Enviar mensagem',
        title: 'Mensagem para o Gerente de Caso',
        translationHeader: 'Saiba mais sobre traduções automáticas',
      },
      ReportCard: {
        addEvidence: 'Adicionar evidência',
        submissionModeVia: 'via {{modoDeEnvio}}',
        viewEvidence: 'Ver evidências',
      },
      ReportList: {
        yourReports: 'Seus Relatórios',
      },
      ReportingActivate: {
        buttonText: 'Continue',
        description:
          'Se a sua organização registrou você para uma conta, enviaremos um e-mail com instruções para completar a configuração.',
        emailInput: 'Email',
        header: 'Digite seu email de trabalho',
        successAccount:
          'Se a sua organização registrou você para uma conta, nós enviaremos um email com instruções para completar a configuração.',
        successEmail:
          'Se você não vê-lo imediatamente, por favor aguarde alguns minutos e atualize sua caixa de entrada de e-mail.',
        successHeading: 'Obrigado',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Adicione evidências ao seu relatório',
        descriptionText:
          'Adicionar arquivos como evidência pode ajudar a suportar a eficiência da resolução pelo seu gerente de caso. Por favor, considere o conteúdo do arquivo (incluindo metadados do arquivo) se você deseja permanecer anônimo, e respeite os direitos de outras pessoas e as leis aplicáveis. Para mais informações, por favor veja este <a>artigo de ajuda</a>',
        emptyMessage: 'Nenhuma evidência adicional foi enviada',
      },
      ReportingChangePassword: {
        back: 'De volta',
        description:
          'Crie uma senha forte para manter sua conta segura. Comece a digitar para ver as diretrizes abaixo.',
        errorToast: 'Não é possível criar senha, token inválido.',
        header: 'Alterar Senha',
        incorrectCurrentPassword:
          'A senha atual está errada. Por favor, verifique e tente novamente.',
        invalidToken: 'Token inválido',
        passwordUpdated: 'Senha atualizada',
        passwordUpdatedDescription:
          'Sua senha foi atualizada com sucesso. Obrigado por dar esse passo para manter seus dados seguros!',
        passwordUsedBefore: 'Reutilização de senha não permitida',
        passwordUsedBeforeDescription:
          'Para sua segurança, você não pode reutilizar nenhuma das suas últimas seis senhas. Por favor, escolha uma nova senha única para manter sua conta segura e tente novamente.',
        toastDescription:
          'Sua senha foi atualizada com sucesso. Obrigado por dar este passo para manter seus dados seguros!',
        toastMessage: 'Senha atualizada',
        updatePasswordCTA: 'Atualizar senha',
      },
      ReportingConnect: {
        cancelButton: 'Cancelar',
        connectButton: 'Conectar',
        disclaimer:
          'Conectar sua conta Slack à sua conta Vault garante uma conexão segura e privada.<br /><br />Ao conectar, você pode denunciar má condutas ou fazer uma pergunta diretamente no Slack. Você sempre terá a opção de denunciar anonimamente após a conexão. Sua privacidade e segurança são nossas maiores prioridades.',
        heading:
          'A Vault Platform está solicitando permissão para acessar sua conta Slack {{organisationName}}',
        listHeading: 'O que Vault será capaz de fazer?',
        permissionIdentity: {
          extraInfo:
            'Vault terá a capacidade de visualizar a identidade do seu usuário Slack',
          heading: 'Visualize informações sobre a identidade de um usuário',
        },
        permissionNotifications: {
          extraInfo:
            'Vault será capaz de enviar notificações para a sua conta Slack, referente a quaisquer atualizações em um relatório enviado ou pergunta.',
          heading: 'Enviar notificações para você',
        },
        permissionOverview: {
          extraInfo:
            'Vault apresentará uma visão geral de todas as submissões na página inicial',
          heading: 'Visão geral das submissões',
        },
        permissionSubmitReport: {
          extraInfo:
            'Isso concederá a Vault permissão para enviar um relatório ou fazer uma pergunta, diretamente à sua organização, do Slack.',
          heading: 'Envie um relatório ou pergunta em seu nome',
        },
        successfulConnectionDescription:
          'Sua conta Vault e sua conta Slack agora estão conectadas. Você pode agora fechar esta aba e retornar ao Slack.',
        successfulConnectionHeading: 'Conectado com sucesso',
        unsuccessfulConnectionDescription:
          'Algo deu errado. Por favor, feche esta aba e volte para o Slack para tentar novamente.',
        unsuccessfulConnectionHeading: 'Conexão falhou',
      },
      ReportingForgotPassword: {
        description:
          'Insira o endereço de email associado à sua conta e nós lhe enviaremos um link para redefinir sua senha.',
        heading: 'Senha esquecida',
        invalidTokenError: 'Não é possível criar senha, token inválido.',
        passwordReuseError: 'Reutilização de senha não permitida',
        passwordReuseErrorDescription:
          'Para sua segurança, você não pode reutilizar nenhuma das suas últimas seis senhas. Por favor, escolha uma nova senha única para manter sua conta segura e tente novamente.',
        sendLink: 'Enviar link de redefinição',
        sendLinkFailure: 'Algo deu errado',
        sendLinkFailureDescription:
          'Volte para o <a>Hub de Reportagens</a> e tente novamente. Se o problema persistir, entre em contato conosco em <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Link de redefinição de senha enviado',
        sendLinkSuccessDescription:
          'Enviamos um link para redefinir a senha para {{email}}',
        updatePasswordSuccess: 'Senha atualizada',
        updatePasswordSuccessDescription:
          'Sua senha foi atualizada com sucesso. Obrigado por dar este passo para manter seus dados seguros!',
      },
      ReportingLogin: {
        accountFrozen: 'A conta está congelada',
        accountLocked:
          'O login foi tentado muitas vezes incorretamente. A conta está bloqueada por até 1 hora. Não é possível redefinir a senha durante este período.',
        accountLockedPermanently:
          'Sua conta foi bloqueada. Use a opção de redefinir senha para recuperar o acesso ou entre em contato com o administrador do seu sistema para obter mais ajuda.',
        createAccountCTA: 'Registre-se para uma conta',
        currentPassword: 'Senha Atual',
        emailLabel: 'Seu Email',
        forgotPassword: 'Esqueceu sua senha?',
        loginButton: 'Login',
        newPasswordPlaceholder: 'Nova senha',
        passwordFailMessage:
          'Volte para o aplicativo Vault no Slack e tente novamente. Se o problema persistir, entre em contato conosco em techsupport@vaultplatform.com',
        passwordFailTitle: 'Algo deu errado',
        passwordLabel: 'Sua Senha',
        passwordPlaceholder: 'Digite sua senha',
        passwordResetRequired: 'Redefinição de senha necessária',
        passwordSuccessfullySetMessage:
          'Volte para o aplicativo Vault no Slack e autentique-se com sua nova senha para continuar de onde parou.',
        passwordSuccessfullySetTitle: 'Senha definida com sucesso',
        reenterPlaceholder: 'Digite novamente a senha',
        title: 'Hub de Reportagem',
        tooltip:
          'Se você nunca definiu uma senha para o aplicativo Vault, siga aqui para começar. Se você esqueceu sua senha, use o link "Esqueci a Senha" abaixo.',
        usernameLoginFailed:
          'Falha no login, nome de usuário ou senha incorretos',
      },
      ReportingReset: {
        failureDescription:
          'Volte para o aplicativo Vault no Slack e tente novamente. Se o problema persistir, entre em contato conosco em <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Algo deu errado',
        successDescription:
          'Volte para o aplicativo Vault no Slack e autentique-se com sua nova senha para continuar de onde parou',
        successHeading: 'Senha definida com sucesso',
      },
      noReports: {
        description:
          'Todos os relatórios enviados serão exibidos aqui. Saiba mais sobre as maneiras de enviar um relatório em',
        descriptionHelpArticle: 'este artigo de ajuda',
        errorDescription:
          'Estamos com dificuldades para carregar seus relatórios. Por favor, tente atualizar a página.',
        errorDescriptionSecondary:
          'Se isso não funcionar, por favor entre em contato conosco em',
        errorTitle: '⚠️ Ops, algo deu errado',
        title: 'Você ainda não tem relatórios',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Ative as traduções automáticas e leia todas as mensagens de relatório no seu idioma preferido. O idioma traduzido é baseado no idioma selecionado no seu dispositivo.',
          autoTranslationDescription2:
            'Você pode alternar entre a língua traduzida e original em cada chat.',
          autoTranslationTitle:
            'Ativar auto-traduções para mensagens de relatório',
          header: 'Configurações de Mensagem',
          subHeader: 'Configure como as mensagens são exibidas',
        },
        notificationSettings: {
          emailDescription:
            'Receba notificações por e-mail para atualizações importantes em seus relatórios',
          emailTitle: 'Notificações por Email',
          header: 'Configurações de Notificação',
          subHeader: 'Configure como você recebe notificações',
        },
        title: 'Configurações',
        updatedSettingsFailure: 'Falha ao atualizar suas configurações',
        updatedSettingsSuccess: 'Atualizou suas configurações com sucesso',
      },
    },
    validators: {
      passwordLength: 'A senha deve ter, no mínimo, nove caracteres',
      passwordLowercase: 'A senha deve conter, no mínimo, uma letra minúscula',
      passwordMissMatch:
        'Os campos de senha e de confirmação devem ter a mesma senha.',
      passwordNumeric: 'A senha deve conter, no mínimo, um número',
      passwordUppercase: 'A senha deve conter, no mínimo, uma letra maiúscula',
    },
    validatorsNew: {
      passwordLength: 'Entre 10 e 30 caracteres',
      passwordLowercase: 'Pelo menos uma letra minúscula',
      passwordMissMatch: 'As senhas não correspondem',
      passwordNumeric: 'Pelo menos um número',
      passwordSpecialCharacter: 'Pelo menos um caractere especial',
      passwordUppercase: 'Pelo menos uma letra maiúscula',
    },
  },
};

export default translations;
